import { trigger, style, transition, animate } from '@angular/animations';

export const FadeOut = [
  trigger('FadeOut', [
    transition(':leave', [
      animate(300, style({ opacity: 0 }))
    ])
  ]),
]
